'use client'

import Image from 'next/image'
import Link from 'next/link'

import { asHttpSrc } from '@/lib/utils'

import type { FooterType } from '@/types/contentful/footerType'

export const SocialIcons = ({ icons }: { icons: FooterType['fields']['socialIcons'] }) => {
  return icons?.map((icon, i) => {
    const iconSrc = asHttpSrc(icon?.fields?.logo?.fields?.file?.url)
    const url = icon?.fields?.url
    if (!iconSrc) return null

    return (
      <li key={i} className="list-none">
        <Link href={url ?? ''}>
          <Image src={iconSrc} alt={icon?.fields?.name} width={24} height={24} />
        </Link>
      </li>
    )
  })
}
